
import fetchClient from "./fetchClient";
import { getEnvironment360BizURL, getFetchApiOptions, ApiConfig } from '../configs/appConfig';
import { getTokenUnified } from "./msalUtil";
import { IConfigInfo } from "../../@types/models";
import { isInteractiveAuthEnabled } from "./authService";

export const getConfigs = async () => {

    const headers = await getHeaders();
    try {
        const response = await fetchClient(getEnvironment360BizURL() +
            ApiConfig.getConfig, {
            method: "POST",
            headers: headers,
            ...getFetchApiOptions()
        }) as IConfigInfo;

        // Optionally, cast or validate the response here if you know the expected type
        return response;
    } catch {
        // Error fetching configurations
        return null;
    }
};

export const getHeaders = async (isStream?: boolean): Promise<Record<string, string>> => {
    // For interactive authentication, don't send Authorization header
    // Rely on cookies being sent via credentials: 'include'
    if (isInteractiveAuthEnabled()) {

        return {
            "Accept": "application/json",
            "Accept-Language": document.documentElement.lang,
            "Content-Type": isStream ? "application/octet-stream" : "application/json"
        };
    }

    // For token-based authentication (MSAL), include Bearer token
    const token = await getTokenUnified();
    return {
        "Accept": "application/json",
        "Accept-Language": document.documentElement.lang,
        "Authorization": `Bearer ${token}`,
        "Content-Type": isStream ? "application/octet-stream" : "application/json"
    };

};

export const getOptiondata = (data?: Uint8Array | string) => {
    return {
        headers: getHeaders(),
        body: data,
        method: "POST",
        ...getFetchApiOptions
    };
};

